module.exports = __webpack_public_path__ + "static/img/right-bottom-row-4.6d5898c3.webp";